/** Client-side row filter for pricing tables and similar lists. */
export function filterBySearch<T>(
  rows: T[],
  query: string,
  keys: ReadonlyArray<keyof T | ((row: T) => unknown)>
): T[] {
  const qq = query.trim().toLowerCase();
  if (!qq) return rows;
  return rows.filter((row) =>
    keys.some((key) => {
      const value = typeof key === 'function' ? key(row) : row[key];
      return String(value ?? '')
        .toLowerCase()
        .includes(qq);
    })
  );
}
